import React, { Component } from 'react';
import { connect } from 'react-redux';
import Drawer from 'housecall-ui/dist/DesignSystem/Navigation/Drawers/Drawer';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import CloseIcon from 'housecall-ui/dist/IconsAndImages/Icons/Close';
import CircularProgress from 'housecall-ui/dist/DesignSystem/Feedback/Progress/CircularProgress';
import TextField from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import VisibilitySensor from 'react-visibility-sensor';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import ActivityFeedItem from './ActivityFeedItem';
import ActivityFeedModel from './ActivityFeedModel';
import { trackButtonClicked } from '../../Services/Analytics/TrackEventsService';
import proTheme from '../../ProTheme.js';

const styles = (theme) => ({
  paper: {
    maxWidth: '420px',
    width: '100%',
  },
  searchBar: {
    paddingBottom: '5px',
    width: '400px',
    maxWidth: '100%',
  },
});

@withStyles(styles)
@connect((state) => ({}), { trackButtonClicked })
export default class ActivityFeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityItems: [],
      searchQuery: '',
      hasMoreItems: false,
    };

    this.model = new ActivityFeedModel();
    this.searchTimeout = null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.isActivityFeedDrawerOpen && !prevProps.isActivityFeedDrawerOpen) {
      this.setState({
        activityItems: [],
        hasMoreItems: true,
        loading: false,
        page: 1,
        searchQuery: '',
      });
    }
  }

  getActivityItems(page) {
    if (this.props.isActivityFeedDrawerOpen && this.state.hasMoreItems) {
      this.setState({ loading: true });

      this.model.getActivityItems(
        page,
        this.state.searchQuery,
        (newActivityItems) => {
          let currentActivityItems = page === 1 ? [] : this.state.activityItems;
          let hasMoreItems = false;

          if (newActivityItems.length > 0) {
            hasMoreItems = true;
            currentActivityItems = currentActivityItems.concat(newActivityItems);
          }

          this.setState({
            loading: false,
            activityItems: currentActivityItems,
            hasMoreItems,
            page: page + 1,
            errorMessage: null,
          });
        },
        (errorMessage) => {
          this.setState({ loading: false, errorMessage, hasMoreItems: false });
        }
      );
    }
  }

  onScrollToBottom(isVisible) {
    if (isVisible && !this.state.loading) {
      this.getActivityItems(this.state.page);
    }
  }

  getLoadingView() {
    if (this.state.loading) {
      return <CircularProgress variant="indeterminate" style={{ display: 'block', margin: '0 auto' }} />;
    }
  }

  onSearchInputChanged(event) {
    this.setState({ searchQuery: event.target.value, hasMoreItems: true }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.props.trackButtonClicked('activity feed searched');
        const firstPage = 1;
        this.setState({ page: firstPage });
        this.getActivityItems(firstPage);
      }, 800);
    });
  }

  render() {
    let errorDiv = null;
    if (this.state.errorMessage) {
      errorDiv = (
        <div>
          Error
          <br />
          <Button href={window.location.href} color="primary">
            Refresh
          </Button>
        </div>
      );
    }

    return (
      <HousecallThemeProvider>
        <div className="material-design-redo-wrapper activity-feed">
          <Drawer
            open={this.props.isActivityFeedDrawerOpen}
            onClose={this.props.toggleActivityFeedDrawer}
            anchor="right"
            classNames
            classes={{
              paper: this.props.classes.paper,
            }}
          >
            <div style={{ backgroundColor: proTheme.palette.backgroundColor, display: 'flex', alignItems: 'center' }}>
              <IconButton color="black" onClick={this.props.toggleActivityFeedDrawer}>
                <CloseIcon color={proTheme.palette.black} />
              </IconButton>
              <Typography variant="h3" color="inherit" component="div" onClick={this.props.toggleActivityFeedDrawer}>
                Activity feed
              </Typography>
            </div>
            <div
              className="activity-feed-container"
              style={{ backgroundColor: proTheme.palette.backgroundColor, padding: '10px' }}
            >
              <TextField
                placeholder="Search"
                data-testid="activity-event-search-input"
                value={this.state.searchQuery}
                className={this.props.classes.searchBar}
                onChange={(event) => {
                  this.onSearchInputChanged(event);
                }}
              />
              {this.state.activityItems.map((item, index) => (
                <ActivityFeedItem key={index} item={item} />
              ))}
              {errorDiv}
              {this.getLoadingView()}
              <VisibilitySensor
                onChange={(isVisible) => {
                  this.onScrollToBottom(isVisible);
                }}
              />
            </div>
          </Drawer>
        </div>
      </HousecallThemeProvider>
    );
  }
}
